module.exports = __webpack_public_path__ + "static/media/chicargo-vinyl-image.e24daccc.jpeg";